export default __webpack_public_path__ + "static/media/crown1.6d1fbe93.png";